import { FeatureSetKey as u } from "../../libs/shared/types-protos/dist/squareup/featurama/feature_sets.js";
import { Feature as a } from "../../libs/shared/types-protos/dist/squareup/sub2/data.js";
import { saasUiQueryKey as r } from "../utils/namespaceQueryKey.js";
import { refreshQuery as s } from "../utils/refreshQuery.js";
import { getFallbackQueryClient as o } from "../../utils/queryClient.js";
const i = Object.values(a).filter((e) => typeof e != "string" && e !== a.DO_NOT_USE), S = Object.values(u).filter((e) => typeof e != "string" && e !== u.FEATURE_SET_DO_NOT_USE), y = {
  getFeatureStatuses: (e = {}) => ({
    queryKey: r(["featurama", "bulkRetrieveFeatureStatuses", { params: e }]),
    async queryFn() {
      const { fetchFeaturamaFeatureStatuses: t } = await import("../implementations/featurama/methods.js");
      return t({ keys: e.keys ?? i, ...e });
    },
    staleTime: Number.POSITIVE_INFINITY,
    retry: 0
  }),
  bulkRetrieveFeatureSetStatuses: (e = { featureSetKeys: S }) => ({
    queryKey: r(["featurama", "bulkRetrieveFeatureSetStatuses", { params: e }]),
    async queryFn() {
      const { bulkRetrieveFeatureSetStatuses: t } = await import("../implementations/featurama/methods.js");
      return t(e);
    },
    staleTime: Number.POSITIVE_INFINITY,
    retry: 0
  })
};
async function T(e) {
  const t = e ?? o(), n = r(["featurama", "bulkRetrieveFeatureStatuses"]);
  return await t.fetchQuery(y.getFeatureStatuses({
    consistent: !0,
    keys: i
  })), s(n, e);
}
async function E(e) {
  const t = r(["featurama", "bulkRetrieveFeatureSetStatuses"]);
  return s(t, e);
}
export {
  i as ALL_FEATURES,
  S as ALL_FEATURE_SETS,
  y as featurama,
  E as refreshFeatureSetStatuses,
  T as refreshFeatureStatuses
};
